export class ContactEventRegistry {
    constructor(eventApi) {
        this.replaceMap = new Map();
        this.eventApi = eventApi;
    }
    on(event, handler, opts) {
        this.eventApi.registerSysEventObserver(event, {
            func: handler,
            _account: opts === null || opts === void 0 ? void 0 : opts._account,
        });
    }
    replace(event, key, handler, opts) {
        const oldId = this.replaceMap.get(key);
        if (oldId !== undefined) {
            this.eventApi.unregisterSysEventObserver(event, oldId);
        }
        const newId = this.eventApi.registerSysEventObserver(event, {
            func: handler,
            _account: opts === null || opts === void 0 ? void 0 : opts._account,
        });
        this.replaceMap.set(key, newId);
    }
    once(event, opts) {
        const { timeout = 5000, filter, _account } = opts !== null && opts !== void 0 ? opts : {};
        return new Promise(resolve => {
            let settled = false;
            let timerId = null;
            let observerId;
            const cleanup = async () => {
                if (timerId !== null) {
                    clearTimeout(timerId);
                    timerId = null;
                }
                await Promise.resolve();
                this.eventApi.unregisterSysEventObserver(event, observerId);
            };
            const handler = async (e) => {
                if (settled)
                    return;
                const typed = e;
                if (filter && !filter(typed))
                    return;
                settled = true;
                resolve(typed);
                await cleanup();
            };
            observerId = this.eventApi.registerSysEventObserver(event, {
                func: handler,
                _account,
            });
            timerId = setTimeout(async () => {
                if (settled)
                    return;
                settled = true;
                resolve(null);
                await Promise.resolve();
                this.eventApi.unregisterSysEventObserver(event, observerId);
            }, timeout);
        });
    }
}
